import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import '../styles/AboutUs.css';

const AboutUs = ({ onBack }) => {
  const { t } = useTranslation();
  
  return (
    <div className="about-us-page">
      <div className="about-us-container">
        <button className="back-btn" onClick={onBack} data-testid="about-back-btn">
          {t('aboutUs.back')}
        </button>
        
        <div className="about-content">
          <h1 className="about-title">{t('aboutUs.title')}</h1>
          <p className="about-subtitle">{t('aboutUs.subtitle')}</p>
          
          <div className="about-description">
            <p>{t('aboutUs.description')}</p>
          </div>

          <div className="features-section">
            <h2>{t('aboutUs.keyFeatures')}</h2>
            
            <div className="feature-item">
              <div className="feature-icon">🎯</div>
              <div className="feature-content">
                <h3>{t('aboutUs.feature1Title')}</h3>
                <p>{t('aboutUs.feature1Desc')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">👑</div>
              <div className="feature-content">
                <h3>{t('aboutUs.feature2Title')}</h3>
                <p>{t('aboutUs.feature2Desc')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <div className="feature-content">
                <h3>{t('aboutUs.feature3Title')}</h3>
                <p>{t('aboutUs.feature3Desc')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">💬</div>
              <div className="feature-content">
                <h3>{t('aboutUs.feature4Title')}</h3>
                <p>{t('aboutUs.feature4Desc')}</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🏆</div>
              <div className="feature-content">
                <h3>{t('aboutUs.feature5Title')}</h3>
                <p>{t('aboutUs.feature5Desc')}</p>
              </div>
            </div>
          </div>

          <div className="closing-statement">
            <p>{t('aboutUs.closingStatement')}</p>
          </div>

          <div className="development-notice">
            <p>
              <strong>{t('aboutUs.developmentNotice').split(':')[0]}:</strong>
              {t('aboutUs.developmentNotice').split(':').slice(1).join(':')}
            </p>
          </div>

          <div className="contact-section">
            <h3>{t('aboutUs.contactTitle')}</h3>
            <a href={`mailto:${t('aboutUs.contactEmail')}`} className="contact-email">
              {t('aboutUs.contactEmail')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
